<div
  class="error-card"
  role="alert"
  aria-live="assertive"
  [class.is-closing]="isClosing()"
>
  <div class="error-card__icon-wrap">
    <i class="pi pi-times-circle error-card__icon"></i>
  </div>
  <div class="error-card__body">
    <p class="error-card__title">{{ title() }}</p>
    <p class="error-card__message">{{ message() }}</p>
  </div>
  <button
    type="button"
    class="error-card__retry"
    (click)="retry.emit()"
    [disabled]="isRetrying()"
  >
    <i class="pi pi-refresh" [class.spin]="isRetrying()"></i>
    Reintentar
  </button>
  <button
    type="button"
    class="error-card__close"
    (click)="close()"
    aria-label="Cerrar mensaje de error"
    title="Cerrar"
  >
    <i class="pi pi-times"></i>
  </button>
</div>
